'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var Dialog = require('@material-ui/core/Dialog');
var DialogContent = require('@material-ui/core/DialogContent');
var DialogActions = require('@material-ui/core/DialogActions');
var TextField = require('@material-ui/core/TextField');
var Button = require('@material-ui/core/Button');
var index_es = require('../node_modules/slate-react/dist/index.es.js');
var ClosableDialogTitle = require('../ClosableDialogTitle/ClosableDialogTitle.js');
var links = require('./plugins/links.js');
var index_es$1 = require('../node_modules/slate/dist/index.es.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Dialog__default = /*#__PURE__*/_interopDefaultLegacy(Dialog);
var DialogContent__default = /*#__PURE__*/_interopDefaultLegacy(DialogContent);
var DialogActions__default = /*#__PURE__*/_interopDefaultLegacy(DialogActions);
var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

var LinkDialog = _ref => {
  var {
    isOpen,
    onClose,
    selection
  } = _ref;
  var [url, setUrl] = React__namespace.useState('');
  var editor = index_es.useSlate();
  React__namespace.useEffect(() => {
    if (isOpen && selection) {
      var newUrl = index_es$1.Editor.string(editor, selection);
      setUrl(newUrl);
    }
  }, [isOpen, selection]);
  return /*#__PURE__*/React__namespace.createElement(Dialog__default['default'], {
    open: isOpen,
    onClose: onClose,
    maxWidth: "xs",
    fullWidth: true
  }, /*#__PURE__*/React__namespace.createElement(ClosableDialogTitle.ClosableDialogTitle, {
    onClose: onClose
  }, "Edit Link"), /*#__PURE__*/React__namespace.createElement(DialogContent__default['default'], null, /*#__PURE__*/React__namespace.createElement(TextField__default['default'], {
    variant: "filled",
    label: "URL",
    value: url,
    onChange: event => setUrl(event.target.value)
  })), /*#__PURE__*/React__namespace.createElement(DialogActions__default['default'], null, /*#__PURE__*/React__namespace.createElement(Button__default['default'], {
    onClick: onClose
  }, "Cancel"), /*#__PURE__*/React__namespace.createElement(Button__default['default'], {
    disabled: !url,
    variant: "contained",
    color: "primary",
    onClick: () => {
      links.insertLink(editor, url, selection);
      onClose();
    }
  }, "Save")));
};
LinkDialog.propTypes = {
  isOpen: index.bool,
  onClose: index.func,
  selection: index.object
};

exports.LinkDialog = LinkDialog;
